import { Component } from '@verndale/core';
import { scroll } from 'framer-motion/dom';
import { debounce } from '../helpers';

class ScrollIndicator extends Component {
  private barHeight: number = 0;
  private resizeObserver: ResizeObserver = new ResizeObserver(() => {});

  constructor(el: HTMLElement) {
    super(el);

    if (!this.dom.$footer) {
      this.el.style.display = 'none';
      console.warn('WARNING: No footer element found. Scroll indicator hidden.');
      return;
    }

    this.initBar();
    scroll((progress: number) => this.handleScroll(progress as number));
    this.addResizeObserver();
  }

  addListeners() {
    if (this.dom.$footer) window.addEventListener('resize', debounce(this.initBar.bind(this), 250));
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      $bar: this.el.querySelector('.scroll-indicator__bar') as HTMLElement,
      $dot: this.el.querySelector('.scroll-indicator__dot') as HTMLElement,
      $footer: document.querySelector('.footer') as HTMLElement
    };
  }

  addResizeObserver() {
    this.resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (entry.target === document.body && entry.contentRect) {
          this.initBar();
        }
      }
    });
    this.resizeObserver.observe(document.body);
  }

  handleResize() {
    debounce(this.initBar, 250);
  }

  initBar() {
    if (!this.dom) return;

    const bar = this.dom.$bar as HTMLDivElement;
    const footer = this.dom.$footer as HTMLDivElement;
    const footerRect = footer.getBoundingClientRect();
    const barRect = bar.getBoundingClientRect();
    let barHeight = footerRect.top - barRect.top;
    const remainder = barHeight % 6;
    barHeight -= remainder;

    bar.style.blockSize = `${barHeight}px`;

    this.barHeight = barHeight;
  }

  handleScroll = (progress: number) => {
    const dot = this.dom.$dot as HTMLDivElement;
    dot.style.insetBlockStart = `${Math.ceil(progress * this.barHeight)}px`;
  };

  componentWillUnmount() {
    this.resizeObserver.disconnect();
  }
}

export default ScrollIndicator;
